var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgAccountRequests(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 17",
    fill: "#0094FF",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M15.334 7.864H14V6.531a.667.667 0 10-1.333 0v1.333h-1.333a.666.666 0 100 1.334h1.333v1.333a.666.666 0 101.333 0V9.198h1.334a.667.667 0 000-1.334zM6 8.53A4 4 0 106 .532a4 4 0 000 8zm0-6.666a2.667 2.667 0 110 5.334 2.667 2.667 0 010-5.334zM6 9.864a6.007 6.007 0 00-6 6 .667.667 0 101.333 0 4.667 4.667 0 019.334 0 .667.667 0 101.333 0 6.007 6.007 0 00-6-6z"
  })));
}
export default SvgAccountRequests;